/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SubscriptionsPromoCodesGet200ResponsePromoCodesInner from './SubscriptionsPromoCodesGet200ResponsePromoCodesInner';

/**
 * The SubscriptionsPromoCodesGet200Response model module.
 * @module model/SubscriptionsPromoCodesGet200Response
 * @version 1.0.0
 */
class SubscriptionsPromoCodesGet200Response {
    /**
     * Constructs a new <code>SubscriptionsPromoCodesGet200Response</code>.
     * @alias module:model/SubscriptionsPromoCodesGet200Response
     */
    constructor() { 
        
        SubscriptionsPromoCodesGet200Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubscriptionsPromoCodesGet200Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubscriptionsPromoCodesGet200Response} obj Optional instance to populate.
     * @return {module:model/SubscriptionsPromoCodesGet200Response} The populated <code>SubscriptionsPromoCodesGet200Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubscriptionsPromoCodesGet200Response();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'String');
            }
            if (data.hasOwnProperty('subscriptionId')) {
                obj['subscriptionId'] = ApiClient.convertToType(data['subscriptionId'], 'String');
            }
            if (data.hasOwnProperty('promoCodes')) {
                obj['promoCodes'] = ApiClient.convertToType(data['promoCodes'], [SubscriptionsPromoCodesGet200ResponsePromoCodesInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SubscriptionsPromoCodesGet200Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SubscriptionsPromoCodesGet200Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['customerId'] && !(typeof data['customerId'] === 'string' || data['customerId'] instanceof String)) {
            throw new Error("Expected the field `customerId` to be a primitive type in the JSON string but got " + data['customerId']);
        }
        // ensure the json data is a string
        if (data['subscriptionId'] && !(typeof data['subscriptionId'] === 'string' || data['subscriptionId'] instanceof String)) {
            throw new Error("Expected the field `subscriptionId` to be a primitive type in the JSON string but got " + data['subscriptionId']);
        }
        if (data['promoCodes']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['promoCodes'])) {
                throw new Error("Expected the field `promoCodes` to be an array in the JSON data but got " + data['promoCodes']);
            }
            // validate the optional field `promoCodes` (array)
            for (const item of data['promoCodes']) {
                SubscriptionsPromoCodesGet200ResponsePromoCodesInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} email
 */
SubscriptionsPromoCodesGet200Response.prototype['email'] = undefined;

/**
 * @member {String} customerId
 */
SubscriptionsPromoCodesGet200Response.prototype['customerId'] = undefined;

/**
 * @member {String} subscriptionId
 */
SubscriptionsPromoCodesGet200Response.prototype['subscriptionId'] = undefined;

/**
 * @member {Array.<module:model/SubscriptionsPromoCodesGet200ResponsePromoCodesInner>} promoCodes
 */
SubscriptionsPromoCodesGet200Response.prototype['promoCodes'] = undefined;






export default SubscriptionsPromoCodesGet200Response;

